import Vue from 'vue'

import './plugins/axios'
import './plugins/vuex'
import './plugins/vuelidate'
import './plugins/v-tooltip'
import { i18n } from './plugins/vue-i18n'

import './filters/engraved-id'
import App from './App'
import getConfig from './config'
import useContainerPlugin from './plugins/container'
import buildContainer from './service'
import useLogPlugin from './plugins/log'
import useVuexRouterSyncPlugin from './plugins/vuex-router-sync'

import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import './assets/scss/style.scss'

Vue.config.productionTip = false

getConfig().then(config => {
  const container = buildContainer(config)
  useContainerPlugin(container)
  useLogPlugin(container)
  useVuexRouterSyncPlugin(container)

  if (config.sentryEnable && config.sentryDsn) {
    Raven
      .config(config.sentryDsn)
      .addPlugin(RavenVue, Vue)
      .install()
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    i18n,
    router: container.router,
    store: container.store,
    components: { App },
    // created: () => {
    //   container.log.debug('We may be (un-)authenticated (via SSO), so let\'s try to fetch the user')
    //   this.$store.dispatch('user/tryFetchUser')
    // },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js